// Ambiente do site dev HOSPEDADO (euro-pgdestagiarios-web.duka.dev).
// Usa URLs absolutas da API dev — lá não existe o proxy do ng serve.
// Localmente use o environment.ts (caminhos relativos + proxy.conf.json).
export const environment = {
    production: false,
    client_id: 'adcd88a9-8ed3-4440-ba05-cf0fa86bfffd',
    tenant_id: '65077b68-6db1-4a06-b930-a013aecff707',
    isLocal: true,
    isLoginMock: true,
    base_graphql: 'https://euro-pgdestagiarios-service.duka.dev/graphql/',
    base_url: 'https://euro-pgdestagiarios-service.duka.dev/v1',
};
